import {
  PayeeRequirement,
  RequirementStatus
} from "@wingspanhq/wingspan-api-sdk";
import { useHistory, useRouteMatch } from "react-router-dom";

import { PATH_EMBEDDED_ONBOARDING } from "../../../Embedded/paths";
import { RequirementsTable } from "../../../Requirements/components/RequirementsTable";
import { useRequirementInstructionsModal } from "../../../Requirements/components/RequirementsDetails/useRequirementInstructionsModal";
import { selectorIsInstructionsModalAvailable } from "../../../Requirements/selectors/selectorIsInstructionsModalAvailable";
import { RequirementContextType } from "../../../Requirements/types";
import { PATH_ONBOARDING_PAYEE } from "../../index";

const getRequirementDetailsPath = (
  requirementId: string,
  isEmbedded: boolean
) =>
  isEmbedded
    ? `${PATH_EMBEDDED_ONBOARDING}/eligibility-requirements/${requirementId}`
    : `${PATH_ONBOARDING_PAYEE}/requirements/${requirementId}/details`;

export const PayerRequirements: React.FC<{
  requirements: PayeeRequirement[];
}> = props => {
  const history = useHistory();
  const requirementInstructionsModal = useRequirementInstructionsModal();
  const isEmbedded = !!useRouteMatch(PATH_EMBEDDED_ONBOARDING);

  return (
    <RequirementsTable
      requiredAction="Start"
      onViewDetails={async (requirement, additionalData) => {
        if (requirement.status !== RequirementStatus.COMPLETED) {
          if (
            selectorIsInstructionsModalAvailable(requirement, additionalData)
          ) {
            const instructionsResult = await requirementInstructionsModal.open({
              requirementId: requirement.id!
            });

            if (instructionsResult !== true) return;
          }
        }

        history.push(getRequirementDetailsPath(requirement.id!, isEmbedded));
      }}
      contextType={RequirementContextType.Payer}
      requirements={props.requirements}
    />
  );
};
